import { render, staticRenderFns } from "./RowChildCountOre.vue?vue&type=template&id=680896e0&scoped=true"
import script from "./RowChildCountOre.vue?vue&type=script&lang=js"
export * from "./RowChildCountOre.vue?vue&type=script&lang=js"
import style0 from "./RowChildCountOre.vue?vue&type=style&index=0&id=680896e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680896e0",
  null
  
)

export default component.exports